import React from 'react'

import { Row, Col, Button } from '_zari/core'

import * as Sections from './sections'

const SectionsCodes = {
  INFORMACION_PERSONAL: 'INF_PER',
  SEGURIDAD: 'SEG'
}

const PerfilPage = () => {
  const [activeSection, setActiveSection] = React.useState(SectionsCodes.INFORMACION_PERSONAL)

  const clickCambioSection = React.useCallback(nuevo => {
    setActiveSection(nuevo)
  }, [])

  return (
    <Row>
      <Col md={2}>
        <Row className='mb-2'>
          <Col md={12}>
            <Button
              block
              tiny
              outline={activeSection !== SectionsCodes.INFORMACION_PERSONAL}
              onClick={() => clickCambioSection(SectionsCodes.INFORMACION_PERSONAL)}
            >
              Información Personal
            </Button>
          </Col>
        </Row>
        <Row>
          <Col md={12}>
            <Button
              block
              tiny
              outline={activeSection !== SectionsCodes.SEGURIDAD}
              onClick={() => clickCambioSection(SectionsCodes.SEGURIDAD)}
            >
              Seguridad
            </Button>
          </Col>
        </Row>
      </Col>
      <Col md={10}>
        {activeSection === SectionsCodes.INFORMACION_PERSONAL && <Sections.InformacionPersonalSection />}
        {activeSection === SectionsCodes.SEGURIDAD && <Sections.SeguridadSection />}
      </Col>
    </Row>
  )
}

export default React.memo(PerfilPage)
